import {BmInfoIcon} from "~/components/icons/simpleIcons";
import {commonStyles} from "~/components/banners/_common";

import {BmSimpleBaseInfoBanner, BmSimpleBaseInfoBannerProps} from "../../SimpleBaseInfoBanner";

export const BmSimpleInfoNotificationBanner: React.FC<BmSimpleBaseInfoBannerProps> = ({...restProps}) => {
  return (
    <BmSimpleBaseInfoBanner
      {...restProps}
      colorPreset="navy"
      leftColumn={<BmInfoIcon id="info-icon" className={commonStyles.icon} />}
    />
  );
};
